// Connection-state banners: browser disconnected, reconnecting, paused feed. Values freeze;
// ages keep counting. These communicate that a browser-side problem — not the terminals —
// is the cause.

import { C } from '../lib/tokens';
import { fmtTS } from '../lib/format';
import { bannerBtnS, bannerS } from '../lib/styles';
import { useData } from '../store/hooks';
import { feed } from '../store/dataStore';

export function Banners() {
  const feedStatus = useData((s) => s.feedStatus);
  const paused = useData((s) => s.paused);
  const lastEventAt = useData((s) => s.lastEventAt);
  const resyncing = useData((s) => s.resyncing);

  const banners: React.ReactNode[] = [];

  if (feedStatus === 'offline') {
    banners.push(
      <div key="off" role="status" style={bannerS(C.rd)}>
        <span style={{ fontFamily: "'IBM Plex Mono',monospace" }} aria-hidden="true">
          ✕
        </span>
        <span style={{ flex: 1 }}>
          Browser lost connection to the monitoring server. Values are frozen as of{' '}
          {fmtTS(lastEventAt)}; ages keep counting. Reconnecting…
        </span>
        <button onClick={() => void feed.resnapshot()} style={bannerBtnS(C.rd)}>
          Retry now
        </button>
      </div>,
    );
  } else if (feedStatus === 'reconnecting' || feedStatus === 'connecting') {
    banners.push(
      <div key="rec" role="status" style={bannerS(C.am)}>
        <span style={{ fontFamily: "'IBM Plex Mono',monospace" }} aria-hidden="true">
          ↻
        </span>
        <span style={{ flex: 1 }}>Reconnecting — missed updates will be resynchronized automatically.</span>
      </div>,
    );
  } else if (resyncing) {
    banners.push(
      <div key="resync" role="status" style={bannerS(C.bl)}>
        <span style={{ fontFamily: "'IBM Plex Mono',monospace" }} aria-hidden="true">
          ↻
        </span>
        <span style={{ flex: 1 }}>Resynchronizing snapshot…</span>
      </div>,
    );
  }

  if (paused) {
    banners.push(
      <div key="paused" role="status" style={bannerS(C.gy)}>
        <span style={{ fontFamily: "'IBM Plex Mono',monospace" }} aria-hidden="true">
          ⏸
        </span>
        <span style={{ flex: 1 }}>
          Live feed paused. Displayed data is a frozen snapshot from {fmtTS(lastEventAt)}.
        </span>
        <button onClick={() => feed.setPaused(false)} style={bannerBtnS(C.gy)}>
          Resume
        </button>
      </div>,
    );
  }

  return <>{banners}</>;
}
